import { Box, Container } from "@mui/material";
import TopCollectors from "../../../components/TopCollectors/TopCollectors";
import LastShirtsAdded from "../../../components/LastShirtsAdded/LastShirtsAdded";

const Community = () => {
  return (
    <Container maxWidth="lg">
      <Box sx={{ margin: { xs: "2rem 0px", md: "4rem 0px" } }}>
        <LastShirtsAdded />
        <TopCollectors />
      </Box>
    </Container>
  );
};

export default Community;
